import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router';

export default function ProductItem({ product }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();

  // Create URL-friendly slug from product name
  const createSlug = useCallback((name) => {
    return name
      .toLowerCase()
      .replace(/[^a-z0-9\s&]/g, '') // Remove special characters except spaces and &
      .replace(/\s*&\s*/g, '-and-') // Replace & with -and-
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
      .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
  }, []);

  // Handle missing images
  const hasImages = product.images && product.images.length > 0;
  const currentImage = hasImages ? product.images[currentImageIndex] : null;

  return (
    <div onClick={
      () => {
        const slug = createSlug(product.name);
        navigate(`/products/product/${product.id}/${slug}`);
      }
    } key={'product_' + product.id} className="product-card">
      <div className="product-image">
        {hasImages ? (
          <img 
            src={currentImage.url} 
            alt={product.name} 
          />
        ) : (
          <div className="product-image-placeholder">
            <span>No Image</span>
          </div>
        )}
        {hasImages && product.images.length > 1 && (
          <div className="product-image-dots">
            {product.images.map((_, index) => (
              <span
                key={index}
                className={`product-dot ${index === currentImageIndex ? 'active' : ''}`}
                onMouseEnter={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        )}
      </div>
      <div className="product-info">
        <div className="product-name">{product.name}</div>
        <div className="product-price">
          {product.coming_soon ? (
            <span style={{
              backgroundColor: '#f59e0b',
              color: '#fff',
              padding: '4px 12px',
              borderRadius: '4px',
              fontSize: '13px',
              fontWeight: '600',
              display: 'inline-block'
            }}>
              Coming Soon
            </span>
          ) : (
            <>
              {product.price.curr} {product.price.amount}
            </>
          )}
        </div>
      </div>
    </div>
  );
}